
import {
    FULLFILL_PATIENT,
    SET_CREATION_PATIENT, SET_EDITED_PATIENT,
    UPDATE_CREATION_PATIENT_FIELD,
    UPDATE_CREATION_PATIENT_VALIDATION, UPDATE_EDITED_PATIENT_VALIDATION
} from '@/store/modules/patients/mutations/available'
import {extractErrorMessages, validate} from '@/helpers/validation'
import Joi from 'joi'
import api from "@/store/modules/patients/api";
import NotificationService from "@/services/notificationService";
import {extractUserErrorMessage, extractValidationErrors} from "js-core/helpers/api";

const creationPatientFieldsValidationSchema = {
    name: Joi.string().min(3).max(255).required(),
    email: Joi.string().email({tlds: {allow: false}}).max(255).allow(null).optional(),
    address: Joi.string().min(3).max(255).allow(null).optional(),
    birthday: Joi.string().min(10).max(10).allow(null).optional(),
}

const creationPatientValidationSchema = Joi.object({
    name: creationPatientFieldsValidationSchema.name,
    email: creationPatientFieldsValidationSchema.email,
    address: creationPatientFieldsValidationSchema.address,
    birthday: creationPatientFieldsValidationSchema.birthday
}).unknown()

export const initCreationPatient = async ({commit, rootState, rootGetters}) => {
    await commit(SET_CREATION_PATIENT, {
        isValid: false,
        validationErrorsByFields: {},
        data: {
            name: null,
            gender: 'f',
            birthday: null,
            address: null,
            phone: null,
            email: null,
            comment: null,
        }
    })
}

export const updateCreationPatientField = async ({dispatch, commit}, {fieldName, value}) => {
    commit(UPDATE_CREATION_PATIENT_FIELD, {
        fieldName,
        value
    })

    await dispatch('validateCreationPatientField', {fieldName, value})
}

export const validateCreationPatientField = async ({state, commit}, {fieldName}) => {
    if (!creationPatientFieldsValidationSchema[fieldName]) {
        return
    }

    let validationResult = validate(creationPatientFieldsValidationSchema[fieldName], state.creationPatient.data[fieldName])

    const errors = extractErrorMessages(validationResult)

    commit(UPDATE_CREATION_PATIENT_VALIDATION, {
        errorsByFields: {
            [fieldName]: errors
        }
    })
}

export const validateCreationPatient = async ({state, commit}) => {
    let validationResult = validate(creationPatientValidationSchema, state.creationPatient.data)

    const errorsByFields = extractErrorMessages(validationResult, true)

    commit(UPDATE_CREATION_PATIENT_VALIDATION, {
        errorsByFields,
        reset: true
    })
}

export const createPatient = async ({dispatch, state, commit, rootGetters}) => {
    await dispatch('validateCreationPatient')

    if (!state.creationPatient.isValid) {
        return
    }

    if (rootGetters.progress('patients.createPatient')) {
        return
    }

    dispatch('startProgress', 'patients.createPatient', {
        root: true
    })

    let createdPatient = false

    try {
        const patient = await api.create(state.creationPatient.data)
        commit(SET_CREATION_PATIENT, patient)
        NotificationService.success('Patient was created')

        createdPatient = patient
    } catch (e) {
        const errorsByFields = extractValidationErrors(e)

        if (errorsByFields !== null) {
            commit(UPDATE_CREATION_PATIENT_VALIDATION, {
                errorsByFields,
                reset: true
            })
        } else {
            NotificationService.error(extractUserErrorMessage(e, 'Unable to create patient'))
        }
    } finally {
        dispatch('stopProgress', 'patients.createPatient', {
            root: true
        })
    }

    return createdPatient
}